import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { CssSelectors } from '../../styles/styles';

const {
	colors,
	common: { border },
} = THEME;

export const HEADER_CELL_TEXT = {
	fontWeight: 600,
	fontSize: 12,
	letterSpacing: '1.1px',
	textTransform: 'uppercase',
} as CSSProperties;

export const styleSheet = StyleSheet.create({
	// Base table styles
	table: {
		boxSizing: 'border-box',
		borderSpacing: 0,
		borderBottom: border,
		width: '100%',
	},

	tableLoadingState: {
		height: '100%',
		borderBottom: 'none',
	},

	// Header styles
	headerCell: {
		padding: 10,
		...HEADER_CELL_TEXT,
	},

	headerCellSticky: {
		position: 'sticky',
		top: 0,
		left: 0,
		background: colors.hover.light,
		whiteSpace: 'nowrap',
		zIndex: 2,
	},
	headerCellCentered: {
		textAlign: 'center',
		verticalAlign: 'middle',
	},
	row: {
		minHeight: 0,
		height: 'min-content',
		maxHeight: 'min-content',
		...CssSelectors.allChildren(
			{
				paddingLeft: 20,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				paddingRight: 20,
			},
			':last-child'
		),
	},

	rowSticky: {
		position: 'sticky',
		top: 0,
		zIndex: 2,
		background: colors.hover.light,
		boxShadow: '0 0 6px rgba(0,0,0,0.25)',
	},

	// Cell styles
	cell: {
		borderTop: border,
		padding: '16px 10px 16px 10px',
		fontSize: 14,
	},

	cellBorderless: {
		padding: '16px 10px 16px 10px',
	},

	cellSticky: {
		position: 'sticky',
		top: 0,
		left: 0,
		background: colors.background.light,
		whiteSpace: 'nowrap',
		':before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 1,
			height: '100%',
			background: colors.border.main,
			boxShadow: '0 0 6px rgba(0,0,0,0.25)',
		},
		':after': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 1,
			height: '100%',
			background: colors.border.main,
			boxShadow: '0 0 6px rgba(0,0,0,0.25)',
		},
	},

	cellCentered: {
		textAlign: 'center',
		verticalAlign: 'middle',
	},

	stackedCell: {
		display: 'flex',
		flexDirection: 'column',
	},

	// Additional utility styles
	fullHeight: {
		height: '100%',
	},
	headerRow: {
		background: colors.hover.light,
	},
});
